export const MULTI_COLUMN_VEHICLE_MENU = 'MultiColumnVehicleMenuModal'

export const MULTI_COLUMN_FRONT_SIZE = 'MultiColumnFrontSizeModal'

export const MULTI_COLUMN_REAR_SIZE = 'MultiColumnRearSizeModal'

export const INITIAL_STEP = 0
